import { render, staticRenderFns } from "./QualificationHelp.vue?vue&type=template&id=48565b7c"
import script from "./QualificationHelp.vue?vue&type=script&lang=js"
export * from "./QualificationHelp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports